/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

export { ReactPropTypesSecret_1 as __moduleExports, ReactPropTypesSecret_1 as default };
//# sourceMappingURL=ReactPropTypesSecret.js.map
